import { render, staticRenderFns } from "./CalendarBar.vue?vue&type=template&id=4485e9f3&scoped=true&"
import script from "./CalendarBar.vue?vue&type=script&lang=js&"
export * from "./CalendarBar.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBar.vue?vue&type=style&index=0&id=4485e9f3&prod&lang=scss&scoped=true&"
import style1 from "./CalendarBar.vue?vue&type=style&index=1&id=4485e9f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485e9f3",
  null
  
)

export default component.exports